/* eslint-disable unused-imports/no-unused-vars */
'use client'

import { useEffect, useState } from 'react'

import {
  PtkStatsByParentWilayahResponseData,
  SatpenStatsByParentWilayahResponseData,
  YayasanStatsByParentWilayahResponseData,
} from '@/apis/types'

export const getFilteredData = (data, activeChips) => {
  if (activeChips.length === 1) {
    if (activeChips.includes('kab')) {
      return data.filter((item) => item.district.namaWilayah.includes('KAB.'))
    } else if (activeChips.includes('kot')) {
      return data.filter((item) => item.district.namaWilayah.includes('KOTA'))
    }
  } else {
    return data
  }
}

export const useKabKotSwicher = ({ data, isPending }) => {
  const [activeChips, setActiveChips] = useState(['kab', 'kot'])
  const [filteredData, setFilteredData] = useState<
    | SatpenStatsByParentWilayahResponseData[]
    | YayasanStatsByParentWilayahResponseData[]
    | PtkStatsByParentWilayahResponseData[]
  >([])

  const onSearchByWilayah = (keywordLocalSearch: string) => {
    setFilteredData(
      (data?.data || []).filter((item) =>
        item.district.namaWilayah
          .toLowerCase()
          .includes(keywordLocalSearch.toLowerCase())
      )
    )
  }

  useEffect(() => {
    if (!isPending && data) {
      setFilteredData(getFilteredData(data?.data, activeChips))
    }
  }, [activeChips, data, isPending])

  return {
    activeChips,
    setActiveChips,
    filteredData,
    onSearchByWilayah,
  }
}
